module.exports = __webpack_public_path__ + "static/media/like-icon.ccdaec3b.svg";